// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as GeoRegionHook from "../../../data-source/geo-region/repo/GeoRegionHook.bs.js";
import * as CountryContext from "../../../data-source/country-config/context/CountryContext.bs.js";
import * as PlaceOrderContext from "../../../../root/crm/place-order/view/context/PlaceOrderContext.bs.js";
import * as FormInput$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";

function SelectRegionCmp(Props) {
  var setRegion = Props.setRegion;
  var classNameOpt = Props.className;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var match = CountryContext.useContext(undefined);
  var match$1 = PlaceOrderContext.useContext(undefined);
  var geo_region = match$1.state.geo_region;
  var geoRegionInit = geo_region !== undefined ? ({
        key: geo_region.name,
        value: geo_region.name,
        text: geo_region.name
      }) : undefined;
  var match$2 = React.useState(function () {
        return geoRegionInit;
      });
  var setSelectedRegion = match$2[1];
  var geoRegions = GeoRegionHook.useGeoRegions(match.country);
  switch (geoRegions.TAG | 0) {
    case /* Loading */0 :
        return null;
    case /* Live */1 :
        var data = geoRegions._0;
        return React.createElement("div", {
                    className: className
                  }, React.createElement(FormSelectInput$Catalyst.make, {
                        input_props: FormInput$Catalyst.make_props("Region", (function ($$event) {
                                var value = FormHelper$Catalyst.TargetEventWrapper.value($$event);
                                var geoRegionObj = List.find((function (e) {
                                        return e.name === value;
                                      }), data);
                                Curry._1(setSelectedRegion, (function (param) {
                                        return {
                                                key: geoRegionObj.name,
                                                value: geoRegionObj.name,
                                                text: geoRegionObj.name
                                              };
                                      }));
                                return Curry._1(setRegion, geoRegionObj);
                              }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                        select_props: {
                          value: match$2[0],
                          items: FormSelectInput$Catalyst.SelectUtils.getTypeItems(data, (function (x) {
                                  return x.name;
                                })),
                          isNoneRequired: true
                        }
                      }));
    case /* Error */2 :
        return React.createElement("div", undefined, "Could't fetch Geo Regions");
    
  }
}

var make = SelectRegionCmp;

export {
  make ,
  
}
/* react Not a pure module */
